// extracted by mini-css-extract-plugin
module.exports = {"label":"styles_label__XDHpg","description":"styles_description__X1Lxq","skeleton-animation":"styles_skeleton-animation__2km8U"};